'use strict';

(function () {
	angular.module('onboarding.common')
		.filter('tinStatus',
			function () {
				return function (tinStatus) {
					if (tinStatus == 'NotValid')
						return 'Invalid';

					return tinStatus;
				};
			});
})();
